angular.module('leanlaw').factory('reviewService', ['$q', 'userService', function ($q, userService) {
  const _ready = $q.defer();
  const localState = {
    stages: [],
    options: {},
    ready: _ready.promise,
    reset: initiateState,
    invoiceLabel,
    invoiceColor
  };
  initiateState();
  const actions = {
    // workflow
    undo: {
      id: 'undo',
      label: 'Undo',
      actions: {
        undo: true
      },
      prompt: "Undo ##? This will release time entries and expenses and put them back in 'Ready to Bill'.",
      show: me => me && me.permissions.billing.create
    },
    undoToDraft: {
      id: 'draft',
      label: 'Back to Draft',
      actions: {
        draft: true
      },
      prompt: 'Bring ## back to draft? This will move the invoices back to the draft folder',
      show: me => me && me.permissions.billing.approve
    },
    undoToReview: {
      id: 'review',
      label: 'Back to Review',
      actions: {
        review: true
      },
      prompt: 'Bring ## back to draft? This will move the invoices back to the review folder',
      show: me => me && me.permissions.billing.approve
    },
    recall: {
      id: 'recall',
      label: 'Back to Draft',
      actions: {
        recall: true
      },
      prompt: 'Bring ## back to draft? This will remove the invoices from QuickBooks and put them in the draft folder in LeanLaw',
      show: me => me && me.permissions.billing.submit
    },
    approve: {
      id: 'approve',
      label: 'Approve',
      actions: {
        approve: true
      },
      prompt: 'Approve ##?',
      show: me => me && me.permissions.billing.approve
    },
    approveAndSubmit: {
      id: 'approve',
      label: 'Approve',
      actions: {
        approve: true
      },
      prompt: 'Approve ##?',
      dropdown: [{
        id: 'approve',
        label: 'Approve and Submit to QuickBooks',
        actions: {
          approve: true,
          submit: true
        },
        prompt: 'Approve ## and submit to QuickBooks?',
        show: me => me && me.permissions.billing.submit
      }],
      show: me => me && me.permissions.billing.approve
    },
    review: {
      id: 'review',
      label: 'Review',
      actions: {
        review: true
      },
      prompt: 'Review ##?',
      show: me => me && me.permissions.billing.approve
    },
    submit: {
      id: 'qbosubmit',
      label: 'Submit to QuickBooks',
      actions: {
        submit: true
      },
      prompt: 'Submit ## to QuickBooks?',
      show: me => me && me.permissions.billing.submit
    },
    submitToApprove: {
      id: 'approve',
      label: 'Submit to Approve',
      actions: {
        submit: true
      },
      prompt: 'Submit ## to Approve?',
      show: me => me && me.permissions.billing.submit
    },
    // delivery
    email: {
      id: 'email',
      label: 'Email',
      actions: {
        send: true
      },
      prompt: 'Email ## to the client(s)?'
    },
    emailCustomization: {
      id: 'email',
      label: 'Email',
      actions: {
        emailCustomization: true
      }
    },
    singleInvoiceCustomization: {
      id: 'email',
      label: 'Email Invoices Individually',
      actions: {
        emailCustomization: true
      }
    },
    multiInvoiceCustomization: {
      id: 'multiEmail',
      isMultiInvoiceOption: true,
      label: 'Email Invoice Group',
      actions: {
        groupInvoiceEmail: true
      }
    },
    multiInvoicePrint: {
      id: 'pdf',
      isMultiInvoiceOption: true,
      label: 'Print Invoice Group',
      actions: {
        groupInvoicePdf: true
      }
    },
    pdf: {
      id: 'pdf',
      label: 'Combined PDF (Print)',
      actions: {
        print: true
      },
      show: (me, invoice) => !invoice
    },
    download: {
      id: 'download',
      label: 'Download as PDFs (ZIP)',
      actions: {
        download: true
      },
      show: (me, invoice) => !invoice
    },
    ledes: {
      id: 'ledes',
      label: 'LEDES',
      actions: {
        ledes: true
      },
      show: (me, invoice) => !invoice || invoice.client.codes && invoice.client.codes.ledes
    },
    combinedLedes: {
      id: 'combined_ledes',
      label: 'Combined LEDES',
      actions: {
        combine: true,
        ledes: true
      },
      show: (me, invoice) => !invoice || invoice.client.codes && invoice.client.codes.ledes
    },
    attachmentPlusLedes: {
      id: 'attachmentsPlusLedes',
      label: 'LEDES & Expenses',
      noBulk: true,
      actions: {
        attachments: true,
        ledes: true
      },
      show: (me, invoice, codesExpenseAttachments) => invoice && invoice.client.codes && invoice.client.codes.ledes && me.features.expenseAttachments && invoice.hasExpenseAttachments && codesExpenseAttachments
    },
    // bulk date change
    bulkInvoiceDateChange: {
      id: 'bulkInvoiceDateChange',
      label: 'Change Invoice Date',
      actions: {
        bulkInvoiceDateChange: true
      },
      show: () => true
    },
    // payment
    pay: {
      id: 'pay',
      label: 'Record Payment',
      actions: {
        pay: true,
        trust: false
      },
      show: (me, invoice) => !invoice || invoice.state.open,
      prompt: 'Pay ## (creates payment in QuickBooks)?'
    },
    trustPay: {
      id: 'trustpay',
      label: 'Pay from Trust',
      actions: {
        pay: true,
        trust: true
      },
      show: (me, invoice) => !invoice || (invoice.client.billing?.trust || invoice.matter?.billing?.trust) && invoice.state.open,
      prompt: 'Pay ## with trust funds (transfers funds from trust and creates payment in QuickBooks)?'
    },
    evergreenAdjustment: {
      id: 'adjustment',
      label: 'Evergreen Payment Adjustment',
      actions: {
        adjustment: true
      },
      show: (me, invoice) => !invoice || invoice.replenish
    },
    evergreenClear: {
      id: 'clear',
      label: 'Clear Evergreen Pending',
      actions: {
        adjustment: true,
        clear: true
      },
      show: (me, invoice) => !invoice || invoice.replenish
    },
    statement: {
      id: 'statement',
      label: 'Attach Trust Statement',
      actions: {
        statement: true
      },
      show: (me, invoice) => !invoice || (invoice.client.billing?.trust || invoice.matter?.billing?.trust) && invoice.accounting
    }
  };
  async function initiateState() {
    localState.stages = [];
    localState.options = {};
    const me = await userService.me();
    const workflow = me.company.settings.workflow || {};
    const ledesEnabled = me.company.settings.codes && me.company.settings.codes.ledes;
    const approveEnabled = workflow.invoiceApprove;
    const reviewEnabled = workflow.invoiceReview;
    const {
      trustEnabled
    } = me.company.settings;

    // Set up options for the different stages
    localState.options.draft = [actions.submit, actions.undo];
    if (reviewEnabled && approveEnabled) {
      localState.options.draft = [actions.review, actions.approve, actions.undo];
      localState.options.review = [actions.approve, actions.undoToDraft];
      localState.options.approved = [actions.submit, actions.undoToReview, actions.undoToDraft];
    }
    if (approveEnabled && !reviewEnabled) {
      localState.options.draft = [actions.approveAndSubmit, actions.undo];
      localState.options.approved = [actions.submit, actions.undoToDraft];
    }
    if (ledesEnabled) {
      localState.options.draft.push(actions.ledes, actions.combinedLedes);
      if (approveEnabled) {
        localState.options.approved.push(actions.ledes, actions.combinedLedes);
      }
    }
    const deliver = {
      label: 'Deliver',
      id: 'deliver',
      dropdown: [...(me.features.multiInvoiceDelivery ? [actions.singleInvoiceCustomization, actions.multiInvoiceCustomization, actions.multiInvoicePrint] : []), ...(!me.features.multiInvoiceDelivery ? me.features.emailCustomization ? [actions.emailCustomization] : [actions.email] : []), actions.pdf, actions.download]
    };
    if (ledesEnabled) {
      deliver.dropdown.push(actions.ledes, actions.combinedLedes, actions.attachmentPlusLedes);
    }
    localState.options.quickbooks = [actions.recall, deliver];
    let pay = angular.copy(actions.pay);
    if (trustEnabled) {
      pay = {
        id: 'paymenu',
        label: 'Pay',
        dropdown: [actions.pay, actions.trustPay]
      };
    }
    localState.options.quickbooks.push(pay);
    localState.options.quickbooks.push(actions.statement);
    if (trustEnabled && me.company.settings.trust.evergreenService) {
      localState.options.quickbooks.push(actions.evergreenAdjustment);
      localState.options.quickbooks.push(actions.evergreenClear);
    }

    // Set up stages
    localState.stages.push({
      id: 'draft',
      label: 'Draft',
      request: reviewEnabled ? 'draft' : approveEnabled ? 'draft,review' : 'draft,review,approved',
      showDue: false,
      showState: false
    });
    if (reviewEnabled) {
      localState.stages.push({
        id: 'review',
        label: 'Review',
        request: 'review',
        showDue: false,
        showState: false
      });
    }
    if (approveEnabled) {
      localState.stages.push({
        id: 'approved',
        label: 'Approved',
        request: 'approved',
        showDue: false,
        showState: false
      });
    }
    localState.stages.push({
      id: 'quickbooks',
      label: 'QuickBooks',
      request: 'open',
      requestStatus: 'all',
      sync: true,
      showDue: true,
      showState: true
    });
    localState.options.draft.push(actions.bulkInvoiceDateChange);
    reviewEnabled && localState.options.review.push(actions.bulkInvoiceDateChange);
    approveEnabled && localState.options.approved.push(actions.bulkInvoiceDateChange);
    _ready.resolve();
  }
  function invoiceLabel(invoice) {
    if (!invoice || !invoice.state) return '';
    if (invoice.deliveryStatus === 1) return 'to email';
    if (invoice.deliveryStatus === 2) return 'emailed';
    if (invoice.deliveryStatus === 3 || invoice.deliveryStatus === 0) return 'to print';
    if (invoice.deliveryStatus === 4) return 'printed';
    if (invoice.deliveryStatus === 5) return 'emailing';
    if (invoice.deliveryStatus === 6) return 'email failed';
    if (invoice.state.draft) return 'draft';
    if (invoice.state.review) return 'review';
    if (invoice.state.approved) return 'approved';
    return invoice.state.emailed ? 'sent' : 'open';
  }
  function invoiceColor(invoice) {
    if (!invoice || !invoice.state) return '';
    if (invoice.deliveryStatus === 0 || invoice.deliveryStatus === 1 || invoice.deliveryStatus === 3 || invoice.deliveryStatus === 5) {
      return 'bg-action-grey';
    }
    if (invoice.deliveryStatus === 2) return 'bg-emailed-green';
    if (invoice.deliveryStatus === 4) return 'bg-printed-blue';
    if (invoice.deliveryStatus === 6) return 'bg-red-600';
    return invoice.state.emailed ? 'bg-action-green' : 'bg-action-grey';
  }
  return localState;
}]);